let expired = false;
const listeners = new Set<() => void>();

export const sessionExpiredStore = {
  getSnapshot: () => expired,
  subscribe: (listener: () => void) => {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  setExpired: () => {
    if (expired) return;
    expired = true;
    listeners.forEach((l) => {
      l();
    });
  },
  reset: () => {
    if (!expired) return;
    expired = false;
    listeners.forEach((l) => {
      l();
    });
  },
};
